
import { useState, useRef } from 'react';
import '../Assets/Css/pestcontrol.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaIndustry, FaCogs, FaHardHat } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutpest from '../Assets/Image/aboutpestcontrol.avif'
import pestImg from '../Assets/Image/indpestcontrol1.avif';
import birdImg from '../Assets/Image/birdcontrol1.jpg';
import pestImg1 from '../Assets/Image/indpestcontrol2.avif';
import birdImg1 from '../Assets/Image/Bird Control1.avif';
import pestImg2 from '../Assets/Image/indpestcontrol3.avif';
import birdImg2 from '../Assets/Image/Bird Control2.avif';


import fabricationCtaImg from '../Assets/Image/pestcta1.avif';
import { Helmet } from 'react-helmet';

export default function PestBirdControl() {






  const testimonials = [
    {
      message: "We had a severe rodent issue in our facility, but their pest control service eliminated it quickly and efficiently.",
      author: "Facility Manager",
    },
    {

      message: "Their bird control netting and spikes have kept our warehouse clean and bird-free. Great service and quick installation.",
      author: "Operations Supervisor",
    },
    {
      message: "Excellent and eco-friendly pest control solutions. Our office environment is now safe and hygienic.",
      author: "HR & Admin Head",
    },
    {
      message: "The team is punctual, professional, and well-equipped. No more cockroach problems in our cafeteria area.",
      author: "Canteen In-Charge",
    },
    {
      message: "We were struggling with pigeons nesting on our building. Their humane bird control system worked perfectly.",
      author: "Building Maintenance Lead",
    },
  ];




  const pestServices = [
    {
      id: 1,
      title: "Industrial Pest Control",
      description:
        "Comprehensive pest Management Solutions for factories, warehouses, and industrial facilities. From rodent control to insect fumigation, we ensure a clean and safe environment.",
      works: [
        "Initial inspection and risk assessment",
        "Baiting and trapping (rodents, insects)",
        "Fumigation and chemical treatments",
        "Follow-up monitoring and sanitation"
      ],
      benefits: [
        "Protects product quality & workforce safety",
        "Prevents downtime caused by infestations",
        "Compliance with health and safety norms"
      ],
      applicationAreas: [
        "Food processing units",
        "Pharmaceutical plants",
        "Storage warehouses",
        "Manufacturing facilities"
      ],
      image: pestImg,
      relatedImages: [pestImg, pestImg1, pestImg2]
    },
    {
      id: 2,
      title: "Bird (Pigeon) Management Solutions",
      description:
        "Safe and eco-conscious bird repellent methods using UV-sensitive gel, physical deterrents, and gentle sensory disruption. We protect ledges, rooftops, and exposed surfaces from unwanted bird activity.",
      works: [
        "Detailed inspection and bird behavior assessment",
        "Application of UV-reflective gel in problem areas",
        "Incorporation of sensory-based visual and touch repellents",
        "Routine upkeep and effectiveness monitoring"
      ],
      benefits: [
        "Minimizes health concerns from bird waste",
        "Shields buildings from corrosion and nesting damage",
        "Preserves the clean and professional appearance of structures"
      ],
      applicationAreas: [
        "Office complexes",
        "Multi-level parking zones",
        "Luxury accommodations",
        "Large storage spaces and factories"
      ],
      image: birdImg,
      relatedImages: [birdImg, birdImg1, birdImg2]
    }

  ];

  const [activeImages, setActiveImages] = useState(
    pestServices.map((s) => s.image)
  );



  const imageRefs = useRef([]);

  const handleImageClick = (serviceIdx, newImage) => {
    const updatedImages = [...activeImages];
    updatedImages[serviceIdx] = newImage;
    setActiveImages(updatedImages);

    // Scroll smoothly to the main image
    const imageElement = imageRefs.current[serviceIdx];
    if (imageElement) {
      imageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        {/* Basic SEO */}
        <title>Pest & Bird Control Services | Industrial & Commercial | Pradh</title>
        <meta
          name="description"
          content="Pradh offers certified pest and bird control services for industrial and commercial spaces. Safe, compliant, and effective solutions for rodents, insects, and pigeons."
        />
        <meta
          name="keywords"
          content="Pest Control India, Industrial Pest Control, Bird Control Netting, Rodent Fumigation, Insect Control, Pigeon Netting Services, Bird Spikes, Commercial Pest Control, Pest Management Pradh"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Pest & Bird Control Services | Pradh" />
        <meta
          property="og:description"
          content="Safe and effective pest & bird control for commercial and industrial sites. Services include rodent control, fumigation, netting, and more from Pradh."
        />
        <meta property="og:url" content="https://pradh.com/pestbirdcontrol" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/pest-bird-control-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pest & Bird Control Services | Industrial & Commercial | Pradh" />
        <meta
          name="twitter:description"
          content="Certified pest control and bird deterrent services for factories, warehouses, and commercial buildings. Request a quote from Pradh today."
        />
        <meta name="twitter:image" content="https://pradh.com/images/pest-bird-control-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/pest-bird-control" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section6">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Pest & Bird Control <br /> Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">Safe, effective solutions to protect your industrial and commercial spaces.</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Request Quote</a>
        </div>
      </section>

      {/* About Us Section */}


      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={5} className="mb-4 mb-md-0 text-center">
              <img src={aboutpest} alt="Pest Control" className="img-fluid rounded shadow" data-aos="zoom-in" />
            </Col>
            <Col md={7}>
              <h2 className="page-title text-center mb-3" data-aos="fade-up">Overview</h2>
              <p data-aos="fade-up" data-aos-delay="100">
                At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, we provide specialized industrial pest and bird control services—using safe, effective, and compliant techniques tailored for commercial and industrial environments.
              </p>
              <p data-aos="fade-up" data-aos-delay="200">
                Our strategies prevent infestations before they start, protect assets, and maintain hygiene standards—keeping your operations healthy, compliant, and stress-free.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 service-section">
        <Container>
          <h2 className="page-title text-center mb-5" data-aos="fade-up">
            Our Pest & Bird Control Services
          </h2>
          {pestServices.map((s, idx) => (
            <Row key={s.id} className={`align-items-center my-5 service-block ${idx % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
              {/* Image Column */}
              <Col md={6} className="d-flex justify-content-center align-items-center text-center"
                ref={(el) => (imageRefs.current[idx] = el)}
              >
                <div className="main-image-wrapper">
                  <img
                    src={activeImages[idx]}
                    alt={s.title}
                    className="img-fluid rounded shadow main-image"
                    data-aos="zoom-in"
                  />
                </div>
              </Col>

              {/* Content Column */}
              <Col md={6}>
                <div className="service-content p-3 p-md-4 rounded" data-aos="fade-up">
                  <h3 className="fw-bold mb-3 text-highlight">{s.title}</h3>
                  <p className="text-muted">{s.description}</p>

                  <div className="mb-3">
                    <h5 className="fw-semibold">Our Work Includes:</h5>
                    <ul className="custom-list">
                      {s.works.map((work, i) => (
                        <li key={i}>{work}</li>
                      ))}
                    </ul>
                  </div>

                  <Row>
                    <Col md={6}>
                      <h6 className="fw-semibold">Benefits:</h6>
                      <ul className="custom-list">
                        {s.benefits.map((b, i) => (
                          <li key={i}>{b}</li>
                        ))}
                      </ul>
                    </Col>
                    <Col md={6}>
                      <h6 className="fw-semibold">Application Areas:</h6>
                      <ul className="custom-list">
                        {s.applicationAreas.map((a, i) => (
                          <li key={i}>{a}</li>
                        ))}
                      </ul>
                    </Col>
                  </Row>

                  {/* Related Thumbnails */}
                  <div className="related-images mt-4">
                    <div className="d-flex flex-wrap gap-2">
                      {s.relatedImages.map((img, i) => (
                        <img
                          key={i}
                          src={img}
                          alt={`Related ${s.title} ${i + 1}`}
                          onClick={() => handleImageClick(idx, img)}
                          className={`img-thumbnail thumb-imagemain ${activeImages[idx] === img ? 'active-thumb' : ''
                            }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          ))}
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in">
              <h2>Protect Your Facility Today</h2>
              <p className="lead">Hassle-free, certified pest and bird control service that keeps your property safe and compliant.</p>
              <a href="/contact" className="btn-get">Contact Us</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={fabricationCtaImg}
                  alt="Steel Structure Team"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p >⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
